import React from "react";

import DragIndicatorIcon from "@mui/icons-material/DragIndicator";

import { ButtonBase, useMediaQuery } from "@mui/material";

import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";
import LineSeparator from "commons/ui/LineSeparator";

import AddRemoveInput from "components/ui/AddRemoveInput";
import AttachmentPicker from "components/ui/AttachmentPicker";

import { LanguageOrderableImagesHook } from "hooks/useLanguageOrderableImages";

import { LanguageEnum } from "types/api/commons";
import { DesktopOrMobile } from "types/enums";

type PropsType = {
    languageOrderableImagesHook: LanguageOrderableImagesHook;
};

function LanguageOrderableImages({ languageOrderableImagesHook }: PropsType) {
    const { deleteRow, setImage, addImage, dragAndDropHook, formHook, visibleItemsLenght } =
        languageOrderableImagesHook;

    const noSpace = useMediaQuery(`(max-width: 1200px)`);

    const { form, checkErrorVisibility } = formHook;

    const [draggable, setDraggable] = React.useState<boolean>(false);

    return (
        <>
            <LineSeparator style={{ marginTop: "1rem" }} />

            {visibleItemsLenght > 0 ? (
                <GridRow>
                    <div className={"col-xs-24-1"}></div>
                    <GridItem className={"col-xs-24-10"}>
                        <h3>Italiano</h3>
                    </GridItem>

                    <div className={"col-xs-24-1"}></div>
                    <GridItem className={"col-xs-24-10"}>
                        <h3>Inglese</h3>
                    </GridItem>
                    <div className={"col-xs-24-2"}></div>
                </GridRow>
            ) : null}

            {form.images.map((image, index) => {
                if (!image.visible || image.toDelete || image.deleted) {
                    return null;
                }

                const divProps: React.DetailedHTMLProps<
                    React.HTMLAttributes<HTMLDivElement>,
                    HTMLDivElement
                > = { className: "col-xs-12-12" };

                if (dragAndDropHook !== undefined) {
                    divProps.className += " " + dragAndDropHook.classes[index]?.join(" ");

                    divProps.onDragStart = () => dragAndDropHook.onDragStart(index);
                    divProps.onDragEnd = () => dragAndDropHook.onDragEnd(index);
                    divProps.onDragOver = (event) => dragAndDropHook.onDragOver(event);
                    divProps.onDragEnter = () => dragAndDropHook.onDragEnter(index);
                    divProps.onDragLeave = () => dragAndDropHook.onDragLeave(index);
                    divProps.onDrop = () => {
                        dragAndDropHook.onDrop(index);
                        setDraggable(false);
                    };
                }

                return (
                    <div key={index} {...divProps} draggable={draggable}>
                        {index === 0 && <LineSeparator style={{ marginBottom: "1rem" }} />}

                        <GridColumn style={{ marginTop: index !== 0 ? "1rem" : "" }}>
                            <GridRow alignItems={"center"}>
                                <div className={"col-xs-24-1 center-icon"}>
                                    <ButtonBase
                                        style={{
                                            paddingBlock: "1rem",
                                        }}
                                        className={"col-xs-12-12 drag-indicator-icon"}
                                        onMouseDown={() => setDraggable(true)}
                                    >
                                        <DragIndicatorIcon />
                                    </ButtonBase>
                                </div>

                                <div className={"col-xl-24-10 col-lg-24-11 col-xs-24-11"}>
                                    <GridRow>
                                        <GridItem className={"col-xs-24-12"}>
                                            <AttachmentPicker
                                                buttonLabel={"Foto Desktop"}
                                                setFile={(file) =>
                                                    setImage(
                                                        file,
                                                        LanguageEnum.it,
                                                        DesktopOrMobile.desktop,
                                                        index
                                                    )
                                                }
                                                file={image.media.it.media.desktop}
                                                accept={".png,.jpg,.jpeg"}
                                                errors={checkErrorVisibility(
                                                    `images.${index}.media.it.media.desktop`
                                                )}
                                            />
                                        </GridItem>

                                        <GridItem className={"col-xs-24-12"}>
                                            <AttachmentPicker
                                                buttonLabel={"Foto Mobile"}
                                                setFile={(file) =>
                                                    setImage(
                                                        file,
                                                        LanguageEnum.it,
                                                        DesktopOrMobile.mobile,
                                                        index
                                                    )
                                                }
                                                file={image.media.it.media.mobile}
                                                accept={".png,.jpg,.jpeg"}
                                                errors={checkErrorVisibility(
                                                    `images.${index}.media.it.media.mobile`
                                                )}
                                            />
                                        </GridItem>
                                    </GridRow>
                                </div>

                                <div className={noSpace ? "" : "col-xs-24-1"}></div>

                                <div className={"col-xl-24-10 col-lg-24-11 col-xs-24-11"}>
                                    <GridRow>
                                        <GridItem className={"col-xs-24-12"}>
                                            <AttachmentPicker
                                                buttonLabel={"Foto Desktop"}
                                                setFile={(file) =>
                                                    setImage(
                                                        file,
                                                        LanguageEnum.en,
                                                        DesktopOrMobile.desktop,
                                                        index
                                                    )
                                                }
                                                file={image.media.en.media.desktop}
                                                accept={".png,.jpg,.jpeg"}
                                                errors={checkErrorVisibility(
                                                    `images.${index}.media.en.media.desktop`
                                                )}
                                            />
                                        </GridItem>

                                        <GridItem className={"col-xs-24-12"}>
                                            <AttachmentPicker
                                                buttonLabel={"Foto Mobile"}
                                                setFile={(file) =>
                                                    setImage(
                                                        file,
                                                        LanguageEnum.en,
                                                        DesktopOrMobile.mobile,
                                                        index
                                                    )
                                                }
                                                file={image.media.en.media.mobile}
                                                accept={".png,.jpg,.jpeg"}
                                                errors={checkErrorVisibility(
                                                    `images.${index}.media.en.media.mobile`
                                                )}
                                            />
                                        </GridItem>
                                    </GridRow>
                                </div>

                                <div
                                    className={
                                        "col-xl-24-2 col-lg-24-1 col-xs-24-1 center-icon center-icon"
                                    }
                                >
                                    <AddRemoveInput
                                        onButtonClick={() => {
                                            deleteRow(index);
                                        }}
                                        minusIcon
                                    />
                                </div>
                            </GridRow>
                        </GridColumn>

                        <LineSeparator style={{ marginTop: "1rem" }} />
                    </div>
                );
            })}

            <GridRow>
                <GridItem
                    className={"col-xl-24-22 col-lg-24-23 col-xs-24-23 center-icon center-icon"}
                ></GridItem>

                <div
                    className={"col-xl-24-2 col-lg-24-1 col-xs-24-1 center-icon center-icon"}
                    style={{ marginBlock: "1rem" }}
                >
                    <AddRemoveInput onButtonClick={addImage} addIcon />
                </div>
            </GridRow>
        </>
    );
}

export default LanguageOrderableImages;
